module.exports = __webpack_public_path__ + "media/assets/images/flags/jo-b4945eda9a37b5a74aaf7851ec51e9d7.svg";